<div class="row">
    <div class="col-sm-12">
        <h1>Work Request Statistics</h1>
    </div>
</div>

<mat-tab-group>
    <!-- #region Monthly Summary -->
    <mat-tab label="Monthly Summary">
        <mat-card class="card-section">
            <mat-card-header>
                <mat-card-title>
                    <span>Monthly Submissions</span>
                </mat-card-title>

            </mat-card-header>

            <mat-card-content class="card-container">
                
                <ngx-charts-line-chart [view]="ss_view" [legend]="ss_legend" [showXAxisLabel]="ss_showXAxisLabel"
                    [showYAxisLabel]="ss_showYAxisLabel" [xAxis]="ss_xAxis" [yAxis]="ss_yAxis" [xAxisLabel]="ss_xAxisLabel"
                    [yAxisLabel]="ss_yAxisLabel" [timeline]="ss_timeline" [results]="submissionSummary">
                </ngx-charts-line-chart>
                <mat-card-header>
                    <mat-card-title>
                        <span>Monthly Summary</span>
                    </mat-card-title>
                </mat-card-header>
                <div class="row">


                    <div class="buttons-right col-md-12">
                        <button type="button" mat-raised-button (click)="exportMonthlyData('xlsx')">Excel</button>
                        <button type="button" mat-raised-button (click)="exportMonthlyData('csv')">CSV</button>


                    </div>
                </div>
                <table mat-table [dataSource]="monthlySummary"  matTableExporter
                    #monthlySummaryExporter="matTableExporter" (exportCompleted)="exportCompleted()" class="mat-elevation-z8">

                    <ng-container matColumnDef="year">
                        <th mat-header-cell *matHeaderCellDef> Year </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.year}} </td>
                    </ng-container>
                    <ng-container matColumnDef="monthStr">
                        <th mat-header-cell *matHeaderCellDef> Month </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.monthStr}} </td>
                    </ng-container>
                    <ng-container matColumnDef="month">
                        <th mat-header-cell *matHeaderCellDef> Month </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.month}} </td>
                    </ng-container>
                    <ng-container matColumnDef="requestType">
                        <th mat-header-cell *matHeaderCellDef> Type </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.requestType}} </td>
                    </ng-container>
                    <ng-container matColumnDef="submitted">
                        <th mat-header-cell *matHeaderCellDef> Submitted </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.submittedRequests}} </td>
                    </ng-container>
                    <ng-container matColumnDef="internalReview">
                        <th mat-header-cell *matHeaderCellDef> Internal Review </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.internalReviewStarted}} </td>
                    </ng-container>
                    <ng-container matColumnDef="inProgress">
                        <th mat-header-cell *matHeaderCellDef> In Progress </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.inProgressStarted}} </td>
                    </ng-container>
                    <ng-container matColumnDef="closed">
                        <th mat-header-cell *matHeaderCellDef> Closed </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.closedRequests}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                </table>


                <mat-paginator #monthlySummaryPaginator [pageSize]="tablePageSize" [pageSizeOptions]="tablePageSizeOptions"> </mat-paginator>

                <div class="footnote">* These statistics reflects work request status change events that occurred each month.</div>

            </mat-card-content>

        </mat-card>

    </mat-tab>
    <!-- #endregion -->    
    <!-- #region Closed Summary -->
    <mat-tab label="Closed Summary">
        <mat-card class="card-section">
            <mat-card-header>
                <mat-card-title>
                    <span>Closed Summary</span>
                </mat-card-title>

                <mat-card-subtitle>

                </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="card-container">

                <div class="row">


                    <div class="buttons-right col-md-12">
                        <button type="button" mat-raised-button (click)="exportClosedData('xlsx')">Excel</button>
                        <button type="button" mat-raised-button (click)="exportClosedData('csv')">CSV</button>


                    </div>
                </div>
                <table mat-table [dataSource]="closedSummary" matSort  matTableExporter
                    #closedSummaryExporter="matTableExporter" (exportCompleted)="exportCompleted()" class="mat-elevation-z8">

                    <ng-container matColumnDef="year">
                        <th mat-header-cell *matHeaderCellDef > Year </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.year}} </td>
                    </ng-container>
                    <ng-container matColumnDef="monthStr">
                        <th mat-header-cell *matHeaderCellDef> Month </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.monthStr}} </td>
                    </ng-container>
                    <ng-container matColumnDef="month">
                        <th mat-header-cell *matHeaderCellDef> Month </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.month}} </td>
                    </ng-container>
                    <ng-container matColumnDef="requestType">
                        <th mat-header-cell *matHeaderCellDef> Request Type </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.requestType}} </td>
                    </ng-container>   
                    <ng-container matColumnDef="count">
                        <th mat-header-cell *matHeaderCellDef> Total </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.count}} </td>
                    </ng-container>                   
                    <ng-container matColumnDef="avgDaysToReview">
                        <th mat-header-cell *matHeaderCellDef> Avg Days to Internal Review </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.avgDaysToReview}} </td>
                    </ng-container>
                    <ng-container matColumnDef="maxDaysToReview">
                        <th mat-header-cell *matHeaderCellDef> Max Days to Internal Review </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.maxDaysToReview}} </td>
                    </ng-container>
                    <ng-container matColumnDef="avgDaysToInProgress">
                        <th mat-header-cell *matHeaderCellDef> Avg Days to In Progress </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.avgDaysToInProgress}} </td>
                    </ng-container>
                    <ng-container matColumnDef="maxDaysToInProgress">
                        <th mat-header-cell *matHeaderCellDef> Max Days to In Progress </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.maxDaysToInProgress}} </td>
                    </ng-container>
                    <ng-container matColumnDef="avgDaysToClosed">
                        <th mat-header-cell *matHeaderCellDef> Avg Days to Closed </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.avgDaysToClosed}} </td>
                    </ng-container>
                    <ng-container matColumnDef="maxDaysToClosed">
                        <th mat-header-cell *matHeaderCellDef> Max Days to Closed </th>
                        <td mat-cell *matCellDef="let rw"> {{rw.maxDaysToClosed}} </td>
                    </ng-container>                    
                    <tr mat-header-row *matHeaderRowDef="displayedClosedSummaryColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedClosedSummaryColumns;"></tr>

                </table>


                <mat-paginator #closedSummaryPaginator [pageSize]="tablePageSize" [pageSizeOptions]="tablePageSizeOptions"> </mat-paginator>

                <div class="footnote">* These statistics reflect the duration in days from the time closed work requests are submitted until the requests are progressed to the next status.</div>

            </mat-card-content>

        </mat-card>

    </mat-tab>
        <!-- #endregion -->

    <!-- #region Request Breakdown (All Requests) -->
    <mat-tab label="Request Breakdown (All Requests)">
        <mat-card class="card-section">
            <!--mat-card-title><h2>All Work Requests - Breakdown By Status - Total: {{totalWorkRequests | number}}</h2></mat-card-title-->
            <mat-card-header>
                <mat-card-title><span>Breakdown By Status (All Requests)</span></mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="card-container">
                <!--
                <div class="row">
                    <mat-card class="card-section-sm col-md-3" *ngFor="let status of statusStatistics; let i = index">
        
                        <mat-card-title>{{status.status}}</mat-card-title>
                        <mat-card-subtitle>{{status.count}}</mat-card-subtitle>
        
                    </mat-card>
        
                </div>
                -->
                <ngx-charts-advanced-pie-chart [view]="[900,300]" label="Work Requests" [results]="overallStatusData"
                    [gradient]="true"
                    [customColors]="chartCustomColors"
                    >
                </ngx-charts-advanced-pie-chart>
                <mat-card-header>
                    <mat-card-title><span>Breakdown By Type (All Requests)</span></mat-card-title>
                    <mat-card-subtitle></mat-card-subtitle>
                </mat-card-header>
                <ngx-charts-advanced-pie-chart [view]="[900,300]" label="Request Type Breakdown" [results]="overallRequestData"
                [gradient]="true"
                
                >
            </ngx-charts-advanced-pie-chart>
            </mat-card-content>
        </mat-card>

    </mat-tab>
    <!-- #endregion -->
    <!-- #region Breakdown of Submitted Requests in Period -->
    <mat-tab label="Breakdown of Requests in Period">
        <mat-card class="card-section">
            <mat-card-header>
                <mat-card-title>Breakdown of Submitted Requests in Period</mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="card-container">
                <div class="row">
                    <mat-form-field class="col-md-3">
                        <mat-label>From Date</mat-label>
                        <input [formControl]="fromDate" matInput [matDatepicker]="picker" placeholder="Choose a date">
                        <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
    
                    </mat-form-field>
    
                    <mat-form-field class="col-md-3">
                        <mat-label>To Date</mat-label>
                        <input [formControl]="toDate" matInput [matDatepicker]="picker2" placeholder="Choose a date">
                        <mat-datepicker-toggle matPrefix [for]="picker2"></mat-datepicker-toggle>
                        <mat-datepicker #picker2></mat-datepicker>
    
                    </mat-form-field>
                    <div class="get-btn col-md-3" >
                        <button class="get-data-btn" mat-raised-button id="get-data" (click)="getStats()" color="primary"
                            type="button" value="submit">Refresh Data</button>
                    </div>
                </div>
    
                <div class="row">
                    <div class="col-sm-3">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Total Submitted</mat-card-title>
                            <mat-card-subtitle>{{stats.submittedRequests}}</mat-card-subtitle>

                        </mat-card>
                    </div>
                    <div class="col-sm-3">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Internal Reviews Initiated</mat-card-title>
                            <mat-card-subtitle>{{stats.internalReviewStarted}}</mat-card-subtitle>

                        </mat-card>
                    </div>
                    <div class="col-sm-3">
                        <mat-card class="card-section-sm">

                            <mat-card-title>In Progress Initiated</mat-card-title>
                            <mat-card-subtitle>{{stats.inProgressStarted}}</mat-card-subtitle>

                        </mat-card>
                    </div>
                    <div class="col-sm-3">
                        <mat-card class="card-section-sm">
                            <mat-card-title>Closed</mat-card-title>
                            <mat-card-subtitle>{{stats.closedRequests| number}}</mat-card-subtitle>

                        </mat-card>
                    </div>
                </div>

                <ngx-charts-bar-vertical [view]="[800,300]" [legend]="true" [xAxis]="true" [yAxis]="true"
                    [results]="periodStatsData" [gradient]="true"
                    [customColors]="chartCustomColors">
                </ngx-charts-bar-vertical>

                <ngx-charts-advanced-pie-chart [view]="[1000,300]" label="Active Requests in Period"
                    [results]="activePeriodStatsData" [gradient]="true"
                    [customColors]="chartCustomColors">
                </ngx-charts-advanced-pie-chart>
                <div class="footnote">* The above statistics reflects work requests <b>submitted</b> during the specified period. Status change events may have occurred outside the date range.</div>
            </mat-card-content>
        </mat-card>
        <mat-card class="card-section">
            <mat-card-header>
                <mat-card-title>Breakdown by Request Type in Period</mat-card-title>
                <mat-card-subtitle></mat-card-subtitle>
            </mat-card-header>

            <mat-card-content class="card-container">
                <div class="row">
                    <div class="col-sm-6">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Submitted Work Orders</mat-card-title>
                            <mat-card-subtitle>{{stats.submittedWorkOrders}}</mat-card-subtitle>

                        </mat-card>
                    </div>
                    <div class="col-sm-6">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Closed Work Orders</mat-card-title>
                            <mat-card-subtitle>{{stats.closedWorkOrders}}</mat-card-subtitle>

                        </mat-card>
                    </div>

                   
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Submitted Consultations</mat-card-title>
                            <mat-card-subtitle>{{stats.submittedConsultations}}</mat-card-subtitle>

                        </mat-card>
                    </div>  
                    <div class="col-sm-6">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Closed Consultations</mat-card-title>
                            <mat-card-subtitle>{{stats.closedConsultations}}</mat-card-subtitle>

                        </mat-card>
                    </div>
                                  
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Started Projects</mat-card-title>
                            <mat-card-subtitle>{{projectPeriodStats.startedProjects}}</mat-card-subtitle>

                        </mat-card>
                    </div>
                    <div class="col-sm-4">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Closed Projects</mat-card-title>
                            <mat-card-subtitle>{{projectPeriodStats.closedProjects}}</mat-card-subtitle>

                        </mat-card>
                    </div> 
                    <div class="col-sm-4">
                        <mat-card class="card-section-sm">

                            <mat-card-title>Active Projects</mat-card-title>
                            <mat-card-subtitle>{{projectPeriodStats.activeProjects}}</mat-card-subtitle>

                        </mat-card>
                    </div> 
             
                </div>
                <ngx-charts-bar-vertical [view]="[1100,300]" [legend]="true" [xAxis]="true" [yAxis]="true"
                [results]="periodRequestTypeData" [gradient]="true"
                >
            </ngx-charts-bar-vertical>
            </mat-card-content>
        </mat-card>

    </mat-tab>
<!-- #endregion -->
</mat-tab-group>